import { Component } from 'react';
import { Card, CardText, CardTitle } from 'reactstrap';
import { COMPANY_NAME, REK_NUMBER } from '../../../constants';

export default class BankTransfer extends Component{
    constructor(props){
        super(props);
        this.state={
            bank:'BCA',
            no_rekening:'7140 324 188',
        }
    }
    render(){
        return (
        <Card body>
            <CardTitle>Bank Transfer</CardTitle>
            <CardText>
                Metode Bank Transfer merupakan metode pembayaran dengan cara transfer ke rekening bersama yang disepakati oleh KICKAVENUE dan para pengguna untuk proses transaksi jual beli di Situs/app KICKAVENUE.
                Detail nomor rekening rekening bersama KICKAVENUE yaitu:
                <br/>
                <br/>
                Bank : {this.state.bank}
                <br/>
                No. Rekening : {`${REK_NUMBER} (${COMPANY_NAME})`}
            </CardText>
            <CardText>Panduan cara membayarnya yaitu:</CardText>
                <CardTitle style={{fontSize:"1rem"}}>Melalui Sesama ATM BCA</CardTitle>
                <ol>
                    <li>Masukkan kartu ATM dan PIN BCA Anda</li>
                    <li>Pilih transaksi <b>LAINNYA</b>.</li>
                    <li>Pilih transfer ke <b>Rekening BCA</b>.</li>
                    <li>Masukan jumlah uang yang akan ditransfer</li>
                    <li>Masukan nomor rekening <b>{REK_NUMBER}</b> atas nama <b>{COMPANY_NAME}</b> lalu pilih <b>BENAR</b>.</li>
                    <li>Layar ATM akan menampilkan data transaksi yang akan diproses. Pilih <b>BENAR</b> jika semua data telah benar.</li>
                    <li>Transaksi Anda sudah selesai. Pilih "TIDAK" untuk tidak melanjutkan transaksi lain</li>
                    <li>Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.</li>
                </ol>
                <CardTitle style={{fontSize:"1rem"}}>Melalui ATM BERSAMA</CardTitle>
                <ol>
                    <li>Masukkan kartu ATM anda ke Mesin ATM yang terdapat logo <b>ATM BERSAMA</b> dan masukkan PIN Anda.</li>
                    <li>Pilih <b>Transfer</b> pada Menu ATM, dan Pilih <b>Transfer ke Bank lain</b> atau <b>Transfer ke ATM Bersama</b>.</li>
                    <li>Masukkan <b>Kode Bank BCA</b> dan Nomor Rekening <b>{REK_NUMBER}</b> atas nama <b>{COMPANY_NAME}</b>.</li>
                    <li>Kemudian masukkan jumlah uang yang akan ditransfer (pastikan angkanya benar)</li>
                    <li>Layar ATM akan menampilkan data transaksi yang akan diproses. Pilih <b>YA</b> jika semua data telah benar.</li>
                    <li>Layar ATM akan menampilkan data transaksi yang akan diproses. Pilih <b>BENAR</b> jika semua data telah benar.</li>
                    <li>Mesin ATM akan mengeluarkan <b>STRUK ATM</b> sebagai bukti transaksi.</li>
                    <li>Transaksi Anda sudah selesai. Pilih "TIDAK" untuk tidak melanjutkan transaksi lain</li>
                    <li>Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.</li>
                </ol>
        </Card>
        )
    }
}
